import React from 'react';
import { FormControlLabel, Switch, styled } from '@material-ui/core';
import PropTypes from 'prop-types';

const SalesStreamSwitch = styled(props => <Switch {...props} />)(() => ({
  width: 40,
  height: 24,
  padding: 0,
  marginLeft: 12,
  marginRight: 12,
  '& .MuiSwitch-switchBase': {
    color: '#fff',
    padding: 4,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      '& + .MuiSwitch-track': {
        backgroundColor: '#FF2C6CDE',
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    height: 16,
    width: 16,
  },
  '& .MuiSwitch-track': {
    borderRadius: 12,
    backgroundColor: '#AFB1B6',
    opacity: 1,
  },
}));

function SwitchInput({ id, label, checked, onChange }) {
  return (
    <FormControlLabel
      control={<SalesStreamSwitch />}
      id={id}
      label={label}
      checked={checked}
      onChange={event => onChange(event.target.checked)}
    />
  );
}

SwitchInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SwitchInput;
